import Vue from 'vue';
import Vuex from 'vuex';
// import axios from 'axios';
import config from '../config';
import * as modules from './modules';


Vue.use(Vuex);


export default new Vuex.Store({
  state: {
    api: {
      baseUrl: config.api,
    },
    loaded: false,
  },
  modules,
  mutations: {

  },

});
